import React from 'react';

import './styles.css';

function UserPhoto(props) {
    return props.src ?
        <img src={props.src} alt={props.alt ? props.alt : 'Foto de perfil'} className={'user-photo ' + (props.className ? props.className : "")}/>
        :
        <span className='user-photo'/>
}

export default UserPhoto;